import { COLORS } from "utils/constants/colors"

export const EQUIPMENT_TYPE_VOLUME_DEFAULT_LEGEND_MODIFIERS = [
  (legendItem) => (legendItem.fillStyle = COLORS.planet.c10),
  (legendItem) => (legendItem.fillStyle = COLORS.neutral.c10),
]
